import {
  INIT_DOCUMENT_LOAD,
  SUBMIT_DOCUMENT_SUCCESS,
  SUBMIT_DOCUMENT_FAILURE,
  SUBMIT_DOCUMENT_REQUEST,
  RESET_UPLOAD_STORE,
  RESET_UPLOAD_STATUS,
  SEND_ME_UPLOAD_LINK_REQUEST,
  QR_CODE_LINK_SUCCESS,
  SEND_ME_UPLOAD_LINK_VIA_SMS_REQUEST,
  UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS,
  FETCH_NEW_DOCUMENT_REQUEST,
  NEW_DOCS_TRUE,
  GO_BACK_TO_SURVEY,
  UPLOAD_PREVENTION_REPORT,
  ADD_DERMATO_PHOTO,
  ADD_PHONE_PHOTO,
  CLEAR_UPLOAD_LINK,
  HYDRATE_UPLOAD,
  MARK_PHONE_PHOTO_DOCS_PROCESSED,
  CLEAR_PROCESSED_PHONE_PHOTO_DOCS,
  FETCH_DERMATO_PATIENT_DETAILS_REQUEST,
  SET_DERMATO_PATIENT_DETAILS,
  MARK_DERMATO_PATIENT_DETAILS_CONSUMED,
} from "./constants"
import { UploadSnapshot } from "containers/Survey/services/surveyStorage"
import { PhonePhotoPayload } from "types/store"

import { UploadedDocumentType } from "../../Survey/types"
import { Action, ActionWithoutPayload} from "types/redux"
import {UploadLink} from "../../../types/store"
interface QrCodeAction {
  type: string
  link: UploadLink
}

export interface UploadLinkRequest {
  path?: string
  standalone: boolean
}

export interface SmsLinkRequest {
  url?: string
  isDermato?: boolean
  standalone?: boolean
}

export interface FetchNewDocumentsRequest {
  linkCreatedAt: string | Date
  standalone: boolean
}

const actions = {
  goBackToSurvey : (): ActionWithoutPayload => ({ type: GO_BACK_TO_SURVEY }),
  reset: (): ActionWithoutPayload => ({ type: RESET_UPLOAD_STORE }),
  // `standalone`: the upload is started outside the survey (Profile > Documents
  // importés), so the link is issued for the account holder.
  generateQrCode: (
    path?: string,
    standalone = false,
  ): Action<UploadLinkRequest> => ({
    type: SEND_ME_UPLOAD_LINK_REQUEST,
    payload: { path, standalone },
  }),
  QrcodeLinkSuccess: (link): Action<QrCodeAction> => ({ type: QR_CODE_LINK_SUCCESS, payload: link }),
  // `standalone`: same meaning as for generateQrCode, the SMS link is issued
  // for the account holder.
  SendLinkViaSMS: (link: SmsLinkRequest): Action<SmsLinkRequest> => ({ type: SEND_ME_UPLOAD_LINK_VIA_SMS_REQUEST, payload: link }),
  linkViaSmsSuccess: (): ActionWithoutPayload => ({ type: UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS }),

  resetStatus: (): ActionWithoutPayload => ({ type: RESET_UPLOAD_STATUS }),
  init: (): ActionWithoutPayload => ({ type: INIT_DOCUMENT_LOAD }),
  submitDocument: (Doc: UploadedDocumentType): Action<UploadedDocumentType> => ({
    type: SUBMIT_DOCUMENT_REQUEST,
    payload: {...Doc},
  }),
  fetchNewDocuments: (
    linkCreatedAt: string | Date,
    standalone = false,
  ): Action<FetchNewDocumentsRequest> => ({
    type: FETCH_NEW_DOCUMENT_REQUEST,
    payload: { linkCreatedAt, standalone },
  }),
  fetchDermatoPatientDetails: (): ActionWithoutPayload => ({
    type: FETCH_DERMATO_PATIENT_DETAILS_REQUEST,
  }),
  setDermatoPatientDetails: (payload: {
    id: string
    text: string
    receivedAt: number
    createdAt: number | null
  }): Action<{
    id: string
    text: string
    receivedAt: number
    createdAt: number | null
  }> => ({
    type: SET_DERMATO_PATIENT_DETAILS,
    payload,
  }),
  markDermatoPatientDetailsConsumed: (receivedAt: number): Action<number> => ({
    type: MARK_DERMATO_PATIENT_DETAILS_CONSUMED,
    payload: receivedAt,
  }),
  newDocsAreAvailable: (num): Action<number> =>({
    type: NEW_DOCS_TRUE,
    payload: num,
  }),
  success: (): ActionWithoutPayload => ({ type: SUBMIT_DOCUMENT_SUCCESS }),
  failure: (error: unknown): Action<{ type: "error"; text: unknown }> => ({
    type: SUBMIT_DOCUMENT_FAILURE,
    payload: { type: "error", text: error },
  }),
  uploadPreventionReport: (): ActionWithoutPayload => ({type: UPLOAD_PREVENTION_REPORT}),
  addDermatoPhoto: (photo: string): Action<string> => ({ type: ADD_DERMATO_PHOTO, payload: photo }),
  addPhonePhoto: (photo: string, key: string): Action<PhonePhotoPayload> => ({
    type: ADD_PHONE_PHOTO,
    payload: { url: photo, key },
  }),
  clearLink: (): ActionWithoutPayload => ({ type: CLEAR_UPLOAD_LINK }),
  hydrateUpload: (snapshot: UploadSnapshot): Action<UploadSnapshot> => ({
    type: HYDRATE_UPLOAD,
    payload: snapshot,
  }),
  markPhonePhotoDocsProcessed: (
    ids: Array<string | number>,
  ): Action<Array<string | number>> => ({
    type: MARK_PHONE_PHOTO_DOCS_PROCESSED,
    payload: ids,
  }),
  clearProcessedPhonePhotoDocs: (): ActionWithoutPayload => ({
    type: CLEAR_PROCESSED_PHONE_PHOTO_DOCS,
  }),
}

export default actions
